import * as React from "react";

import { makeStyles } from "@mui/styles";

import { colors } from "@/styles/constants";
import { formatDate } from "@/utils/Functions";
import { Fieldset } from "@/components/molecules/Fieldset";
import { DashboardInfoContext } from "@/store/DashboardProvider";

export const CaseSummary: React.FC = () => {
  const classes = useStyles();
  const {
    state: { case: caseRecord },
  } = React.useContext(DashboardInfoContext);
  if (!caseRecord) return null;
  return (
    <Fieldset title="Case summary">
      <table>
        <tbody>
          <tr>
            <td className={classes.label}>Deceased</td>
            <td>
              {caseRecord.deceasedFirstName} {caseRecord.deceasedLastName}
            </td>
          </tr>
          <tr>
            <td className={classes.label}>Date of death</td>
            <td>{caseRecord.deceasedAt && formatDate(caseRecord.deceasedAt)}</td>
          </tr>
          <tr>
            <td className={classes.label}>Accounts</td>
            <td>{caseRecord.accounts.length}</td>
          </tr>
          <tr>
            <td className={classes.label}>
              {caseRecord.notifier.role === "executor" ||
              caseRecord.notifier.role === "sole_executor"
                ? "Executor"
                : "Administrator"}
            </td>
            <td>
              {caseRecord.notifier.firstName} {caseRecord.notifier.lastName}
            </td>
          </tr>
        </tbody>
      </table>
    </Fieldset>
  );
};

const useStyles = makeStyles({
  label: {
    color: colors.fadedText,
    paddingRight: "20px",
  },
});
